export default __webpack_public_path__ + "static/media/target.d24fdde1.svg";